import { FormattedMessage } from '@umijs/max'
import { message, Modal } from 'antd'
import { LegacyButtonType } from 'antd/es/button/button'
import React, { useState } from 'react'

type Props = {
  label: string // 按钮文本，例：pages.option.delete
  className?: string // 按钮类名
  title: string // 弹窗标题
  id: number | string // 需删除的资源id
  content?: React.ReactNode // 弹窗内容，默认内容为标题确定要{title}#{id}吗？
  okType?: LegacyButtonType // 确定按钮类型
  onFinish: () => Promise<any> // 确定调用的方法
}

const ConfirmModalBtn: React.FC<Props> = ({
  label,
  className,
  title,
  content,
  id,
  onFinish,
  okType,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <a
        className={className}
        onClick={() => {
          setIsOpen(true)
        }}
      >
        <FormattedMessage id={label} />
      </a>
      <Modal
        title={`${title}#${id}`}
        width={368}
        okType={okType}
        open={isOpen}
        onOk={async () => {
          setIsOpen(false)
          try {
            const res = await onFinish()

            if (typeof res === 'string' && res.includes('失败')) {
              // data 返回字符串可使用返回值进行提示
              message.error(`${res}`)
            } else {
              message.success(`${title}#${id}成功`)
            }
          } catch (error) {
            if (!(error instanceof Error && 'notified' in error && error.notified)) {
              message.error(error instanceof Error ? error.message : `${title}#${id}失败`)
            }
          }
        }}
        onCancel={() => setIsOpen(false)}
      >
        {content ? (
          content
        ) : (
          <p>
            确定要
            {title}#{id}吗?
          </p>
        )}
      </Modal>
    </>
  )
}

export default ConfirmModalBtn
